import menu from "../assets/Menu Buildout.jpg";
import "./styles.css";

function Menu() {
  return (
    <div>
      <div className="about-page">
        <section className="about-hero">
          <h1>Our Menu</h1>
        </section>
      </div>
      <div>
        <section className="menu-section">
          <div>
            <img src={menu} alt="Menu Items" />
          </div>
        </section>
      </div>
    </div>
  );
}

export default Menu;
